module.exports = __webpack_public_path__ + "img/L1060497.6f238742.jpg";